import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30e416c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-steps" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "fontEn" }, [
  /*#__PURE__*/_createTextVNode("STEP"),
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "お見積もり", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "fontEn" }, [
  /*#__PURE__*/_createTextVNode("STEP"),
  /*#__PURE__*/_createElementVNode("span", null, "2")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "お申込者情報", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "fontEn" }, [
  /*#__PURE__*/_createTextVNode("STEP"),
  /*#__PURE__*/_createElementVNode("span", null, "3")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "申込内容確認", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "fontEn" }, [
  /*#__PURE__*/_createTextVNode("STEP"),
  /*#__PURE__*/_createElementVNode("span", null, "4")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "完了", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", null, [
      _createElementVNode("div", {
        class: _normalizeClass({ active: _ctx.currentStep > 0 })
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass({ active: _ctx.currentStep > 1 })
      }, _hoisted_7, 2),
      _createElementVNode("div", {
        class: _normalizeClass({ active: _ctx.currentStep > 2 })
      }, _hoisted_10, 2),
      _createElementVNode("div", {
        class: _normalizeClass({ active: _ctx.currentStep > 3 })
      }, _hoisted_13, 2)
    ])
  ]))
}